import _ from 'lodash'
import wAxios from '@/plugins/w/axios/models/axios'
import { buildQueryFilters, createApiHook } from '@/plugins/app/api'

export interface ResultsFilters {
	search?: string
	accesses?: number[]
	readed?: boolean
	date_sent?: string
	last_result?: {
		start?: string
		end?: string
	}
	sort?: {
		column: string
		asc: boolean
	}
	labs?: string[] // OC: Is it string?
}

export const QUERY_KEY = 'results'

const RESULT_SORT_BY = localStorage.getItem('result_sort_by')

export const DEFAULT_FILTERS: ResultsFilters = {
  search: "",
  accesses: [],
  readed: undefined,
  date_sent: "",
  last_result: {
    start: "",
    end: "",
  },
  ...(RESULT_SORT_BY && { sort: { column: RESULT_SORT_BY, asc: false } }),
  labs: [],
};

export const fetchFn = async (
  pagination: Pagination,
  filters: ResultsFilters = {}
) => {
  if(filters.accesses.length === 0) {
    return {
      data: [],
      meta: {
        last_page: 1,
      },
    };
  }
  const body = fetchQuery(pagination, filters);
  return wAxios
    .post_auth(`v2/requests`, body)
    .catch((error) => Promise.reject(error.response || error));
};

export const fetchQuery = (pagination: Pagination, filters: ResultsFilters) => {
	const filtersWithDefaults = _.defaults(filters, DEFAULT_FILTERS)

	const query = {
		per_page: Number(pagination.per_page),
		page: Number(pagination.current_page),
		search: filtersWithDefaults.search?.trim() || '',
		accesses: filtersWithDefaults.accesses || [],
		has_result: true,
		created_from: '',
		created_to: '',
		last_result_from: '',
		last_result_to: '',
		...(filtersWithDefaults.sort && { sort: filtersWithDefaults.sort }),
		labs: filtersWithDefaults.labs || [],
		readed: filtersWithDefaults.readed
	}

	if (filtersWithDefaults.readed === null || filtersWithDefaults.readed === undefined) {
		delete query.readed
	}

	if (filtersWithDefaults.date_sent && filtersWithDefaults.date_sent !== '') {
		query.created_from = filtersWithDefaults.date_sent
		query.created_to = filtersWithDefaults.date_sent
	} else if (
		filtersWithDefaults.last_result &&
		filtersWithDefaults.last_result.start !== '' &&
		filtersWithDefaults.last_result.end !== ''
	) {
		query.last_result_from = filtersWithDefaults.last_result.start
		query.last_result_to = filtersWithDefaults.last_result.end
	}

	if (query.last_result_from === '' && query.last_result_to === '') {
		delete query.last_result_from
		delete query.last_result_to
	}

	if (query.created_from === '' && query.created_to === '') {
		delete query.created_from
		delete query.created_to
	}

	return query
}

export const useGetResults = createApiHook(fetchFn, QUERY_KEY, fetchQuery)
